/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PostPersonalHealthRecordCsvGenerateResponseTypename =
  "PostPersonalHealthRecordCsvGenerateResponse" as const;

/**
 *
 * @export
 * @interface PostPersonalHealthRecordCsvGenerateResponse
 */
export interface PostPersonalHealthRecordCsvGenerateResponse {
  /**
   *
   * @type {string}
   * @memberof PostPersonalHealthRecordCsvGenerateResponse
   */
  id: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PostPersonalHealthRecordCsvGenerateResponse
   */
  readonly __typename?: string;
}

export function PostPersonalHealthRecordCsvGenerateResponseFromJSON(
  json: any
): PostPersonalHealthRecordCsvGenerateResponse {
  return PostPersonalHealthRecordCsvGenerateResponseFromJSONTyped(json, false);
}

export function PostPersonalHealthRecordCsvGenerateResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PostPersonalHealthRecordCsvGenerateResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PostPersonalHealthRecordCsvGenerateResponseTypename,

    id: json["id"],
  };
}

export function PostPersonalHealthRecordCsvGenerateResponseToJSON(
  object?: PostPersonalHealthRecordCsvGenerateResponse | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    id: value.id,
  };
}
